import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',

    '& .icon': {
      position: 'absolute',
      top: '0',
      left: '0',
      display: 'none',
      borderRadius: '50%',
      background: 'white',
      transform: 'translateX(-25%)'
    },

    '&:hover .icon': {
      display: 'block'
    }
  },

  avatar: {
    border: '2px solid white',
    width: '30px',
    height: '30px',
    fontSize: theme.size.sm
  }
}))

export default useStyles
